<template>
  <div class="modal__header">
    <section class="modal__container">
      <div class="modal__top-row">
        <h2 class="modal__title">{{ title }}</h2>
        <div class="modal__btn-panel">

          <button class="modal__btn" @click="$emit('close')">
            <img src="@/assets/img/svg/close-icon-red.svg" alt="">
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
    name: 'ModalHeader',
    props: ['title'],
}
</script>

<style lang="scss" scoped>
.modal {
  &__header { border-bottom: 1px solid #DADADA; }
  &__container {
    padding: 22px;
  }
  &__top-row {
    display: flex;
    justify-content: space-between;
  }
  &__title {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;

    color: #56565A;
  }
  &__btn-panel {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  &__btn {
    display: flex;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    border: 0;
    background: none;

    cursor: pointer;

    &:hover > span { text-decoration: none; }
    &:focus { outline: none; }

    &_remove { color: #D21242; }
    &_copy { color: #008FC5; }
    & > span { text-decoration-line: underline; margin-right: 5px; transition: all .3s ease; }
  }
}
</style>